module.exports = __webpack_public_path__ + "img/no-data.6a7b6abe.svg";